require('./bootstrap');

import Vue from 'vue'

// Importa il file .js di Vuetify. Su app.scss viene invece caricato il .css! js e css sono entrambi in node_modules/vuetify/..
import vuetify from './plugins/vuetify'

import store from './store';
import router from './router';
// import store from './store';
import mixin from './mixin'; // Funziona solo per i Vue Component, non per le Routes

import VueTour from 'vue-tour'
require('vue-tour/dist/vue-tour.css')
Vue.use(VueTour)

import VueExcelXlsx from "vue-excel-xlsx";
Vue.use(VueExcelXlsx)
// window.moment = require('moment'); // Carico il pacchetto NPM 'moment'

// import moment from 'moment';
// Vue.use(require('vue-moment'));

Object.filter = (obj, predicate) => 
	Object.keys(obj)
				.filter( key => predicate(obj[key]) )
				.reduce( (res, key) => (res[key] = obj[key], res), {} );
                
Vue.component('pagination', require('laravel-vue-pagination'));

/*
    Il seguente codice cerca e definisce automaticamente tutti i componenti.
    Esempio1: ./components/sistema/ExampleComponent1.vue -> <example-component1></example-component1>
    Esempio2: ./components/anagrafica/ExampleComponent2.vue -> <example-component2></example-component2>
*/
const files = require.context('./components/', true, /\.vue$/i);
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default));

// Creato un bus di eventi catturabili da qualunque parte dell'app: 
//    https://www.html.it/pag/68438/components-eventi-custom/ (Comunicazione tra componenti non correlati)
// Guarda anche (da qui ho preso spunto): https://stackoverflow.com/questions/47754830/vuejs-listening-for-event-on-component
// Vue.prototype.$vueEventBus = new Vue(); // Global event bus

// Crea l'istanza Vue
new Vue({
  vuetify,
  router,
  mixins: [mixin],
  store,
  computed: {
    darkMode() {
      return this.$store.state.darkMode;
    }
  },
  watch: {
    darkMode(newVal) {
      // Aggiorna il tema di Vuetify
      this.$vuetify.theme.dark = newVal;

      // Aggiungi o rimuovi la classe 'dark' dall'elemento body
      if (newVal) {
        document.body.classList.add('dark');
      } else {
        document.body.classList.remove('dark');
      }
    }
  },
  created() {
    store.commit('controllaLogin', null);

    // Imposta il tema di Vuetify iniziale
    this.$vuetify.theme.dark = this.darkMode;

    // Aggiungi o rimuovi la classe 'dark' dall'elemento body al caricamento iniziale
    if (this.darkMode) {
      document.body.classList.add('dark');
    } else {
      document.body.classList.remove('dark');
    }
  },
}).$mount('#app');